import React, { useEffect, useState } from 'react';
import MiddlePanel from 'Components/MiddlePanel/MiddlePanel';
import ExternalProductionDays from './ExternalProductionDays/ExternalProductionDays';
import Panel from 'Components/Panel/Panel';
import Button from 'Components/Button/Button';
import ExternalProductionDaysEmployee from './ExternalProductionDaysEmployee/ExternalProductionDaysEmployee';
import ExternalProductionOperations from './ExternalProductionOperations/ExternalProductionOperations';
import './ExternalProductionStyle.css';

const ExternalProduction = ({
    isOpen,
    setIsOpen,
    productionsIdSelecteds
}) => {
    const [productionsDaysIdSelecteds, setProductionsDaysIdSelecteds] = useState([]);
    const [productionsEmployeesSelecteds, setProductionsEmployeesSelecteds] = useState([]);
    const [operationsDaySelecteds, setOperationsDaySelecteds] = useState([]);

    const styleExternalProductionCloseButton = {
        padding: '0px 20px 0px 20px',
        float: 'right',
        color: 'red',
        fontWeight: '600',
        textAlign: 'center',
        fontSize: '0.8em',
        cursor: 'pointer',
        height: '30px'
    };


    return (
        <>
            <MiddlePanel isVisible={isOpen} zIndex={100} overlay={true}>
                <div className='external-production-body'>
                    <Panel
                        titlePage={'Dias de produções'}
                        canViewCRUD={true}
                        className='external-production-panel external-production-days'
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            padding: '5px',
                            borderRadius: '10px',
                            backgroundColor: '#f5f5f5;',
                            border: '1px solid #ccc',
                            boxShadow: '0px 0px 10px rgba(0, 0, 0, 30%)',
                            margin: '1px'
                        }}>
                        <ExternalProductionDays
                            productionsIdSelecteds={productionsIdSelecteds}
                            productionsDaysIdSelecteds={productionsDaysIdSelecteds}
                            setProductionsDaysIdSelecteds={setProductionsDaysIdSelecteds}
                            setProductionsEmployeesSelecteds={setProductionsEmployeesSelecteds}
                            setOperationsDaySelecteds={setOperationsDaySelecteds}
                            isOpen={isOpen}
                        />
                    </Panel>
                    <Panel
                        titlePage={'Colaboradores'}
                        canViewCRUD={true}
                        className='external-production-panel external-production-employees'
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            padding: '5px',
                            borderRadius: '10px',
                            backgroundColor: '#f5f5f5;',
                            border: '1px solid #ccc',
                            boxShadow: '0px 0px 10px rgba(0, 0, 0, 30%)',
                            margin: '1px'
                        }}
                    >
                        <ExternalProductionDaysEmployee
                            productionsDaysIdSelecteds={productionsDaysIdSelecteds}
                            productionsEmployeesSelecteds={productionsEmployeesSelecteds}
                            setProductionsEmployeesSelecteds={setProductionsEmployeesSelecteds}
                            setOperationsDaySelecteds={setOperationsDaySelecteds}
                            isOpen={isOpen}
                        />
                    </Panel>
                    <Panel
                        titlePage={'Operações'}
                        canViewCRUD={true}
                        className='external-production-panel external-production-operations'
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            padding: '5px',
                            borderRadius: '10px',
                            backgroundColor: '#f5f5f5;',
                            border: '1px solid #ccc',
                            boxShadow: '0px 0px 10px rgba(0, 0, 0, 30%)',
                            margin: '1px'
                        }}
                        componentRightButtons={
                            <Button
                                clickMethod={() => {
                                    setIsOpen(false)
                                    setProductionsDaysIdSelecteds([])
                                    setProductionsEmployeesSelecteds([])
                                    setOperationsDaySelecteds([])
                                }}
                                buttonName={'Fechar'}
                                style={styleExternalProductionCloseButton}
                            />
                        }>
                        <ExternalProductionOperations
                            productionsEmployeesSelecteds={productionsEmployeesSelecteds}
                            operationsDaySelecteds={operationsDaySelecteds}
                            setOperationsDaySelecteds={setOperationsDaySelecteds}
                            isOpen={isOpen}
                        />
                    </Panel>
                </div>

            </MiddlePanel>
        </>
    );
};

export default ExternalProduction;


